import React from 'react'
import * as ReactDOMClient from 'react-dom/client'
import App from './App'
import './index.css'
import reportWebVitals from './reportWebVitals'

// Suppress benign ResizeObserver loop warning (W3C spec says it's harmless)
// Capture phase fires before React/webpack error overlays
const RESIZE_ERROR = 'ResizeObserver loop'
window.addEventListener('error', (e) => {
	if (e.message?.startsWith(RESIZE_ERROR)) {
		e.stopImmediatePropagation()
		e.preventDefault()
	}
}, true)

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
